import { t } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";
import { Trans } from "@lingui/react/macro";
import { Typography } from "@mui/material";
import Section from "@/components/Section";
import { useCampground } from "@/contexts/AppConfigContext";
import { useBookingContext } from "@/contexts/BookingContext";
import { formatCurrency, formatPaymentInfo } from "@/utils/pricing";

export default function PaymentInfo() {
  const { state } = useBookingContext();
  const { data: campgroundData } = useCampground();
  const { i18n } = useLingui();
  const formatPrice = (value: number) =>
    state.price ? formatCurrency(value, state.price.currency, i18n.locale) : null;

  const paymentInfo = formatPaymentInfo(state.price?.payment_system || "", i18n);
  const depositPercent = campgroundData.campground?.deposit_percent || 0;
  const minimumFixedDeposit = Number(campgroundData.campground?.minimum_fixed_deposit) || 0;

  if (!paymentInfo) {
    return null;
  }

  return (
    <Section title={t`Payment Information`}>
      <Typography variant="body2">{paymentInfo}</Typography>
      {depositPercent > 0 && (
        <Typography variant="body2" sx={{ mt: 1 }}>
          <Trans>A deposit of {depositPercent}% is required. The rest is to be paid on site.</Trans>
        </Typography>
      )}
      {!depositPercent && minimumFixedDeposit > 0 && (
        <Typography variant="body2" sx={{ mt: 1 }}>
          <Trans>
            A minimum deposit of {formatPrice(minimumFixedDeposit)} is required. The rest is to be
            paid on site.
          </Trans>
        </Typography>
      )}
    </Section>
  );
}
